import React, { useEffect, useMemo, useState } from 'react';
import { Column, Row } from 'react-table';

import { ListingDto, MessageDto, MessageListingDto } from 'services/data-contracts';
import TableBody from 'components/table/TableBody';
import { EditButton } from 'resources/styles/TableStyle';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import PaginationWrapper from '../Pagination';
import { useStoreWrapper } from 'stores/StoreHelper';

interface MessageTableProps {
  messages: MessageDto[];
  onRowClick?: (message: MessageDto) => void;
  onEditClick?: (message: MessageDto) => void;
}


// 테이블 데이터 타입 정의
const MessageTable = observer(({ messages, onRowClick, onEditClick }: MessageTableProps) => {
  const { messageFilterStore } = useStoreWrapper();

  // 테이블 컬럼 정의
  const columns = useMemo(
    () => [
      {
        Header: 'No',
        accessor: 'id' as keyof MessageDto,
        width: 60,
      },
      {
        Header: '메시지명',
        accessor: 'name' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '대상한옥',
        accessor: 'listings' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: ListingDto[] }) => {
          return !value || value.length === 0
            ? '-'
            : value.length > 1
              ? `${value[0].name} 외 ${value.length - 1}개`
              : value[0].name;
        },
      },
      {
        Header: '전송타입',
        accessor: 'type' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '이벤트',
        accessor: 'trigger.event' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '발송시간',
        accessor: 'trigger.triggerType' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '예약타입',
        accessor: 'trigger.reservationType' as keyof MessageDto,
        width: 100,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '숙박인원',
        accessor: 'trigger.guestCount' as keyof MessageDto,
        width: 50,
      },
      {
        Header: '숙박일수',
        accessor: 'trigger.nights' as keyof MessageDto,
        width: 50,
        Cell: ({ value }: { value: string }) => {
          return value;
        },
      },
      {
        Header: '수정',
        id: 'edit',
        width: 80,
        Cell: ({ row }: { row: Row<MessageDto> }) => <EditButton onClick={(e) => {
          e.stopPropagation();
          onEditClick?.(row.original as MessageDto);
        }}>수정</EditButton>,
      },
    ],
    [],
  ) as Column<MessageDto>[];

  return (
    <div>
      <div style={{ paddingBottom: '100px' }}>
        <TableBody columns={columns} data={messages} onRowClick={onRowClick} />
      </div>
      <PaginationContainer>
        <PaginationWrapper count={messageFilterStore.paginationInfo?.totalCount ?? 0}
          totalPages={messageFilterStore.paginationInfo?.totalPages ?? 0} />
      </PaginationContainer>
    </div>
  );
});

const PaginationContainer = styled.div`
    margin-top: 20px;
    position:fixed;
    bottom:0;
    z-index:10;
    margin:auto;
    background:rgba(255,255,255,1);
    backdrop-filter: blur(10px);
    left:0;
    right:0;

    display:flex;
    justify-content:center;
    align-items:center;

`;

export default MessageTable;
